/** Layout das barras; com conflito ignorado a faixa passa a 2,5 e o respiro da linha a 1,5. */
export const LAYOUT_PRESET = "compact";
export const LAYOUT_IGNORED = { laneHeightRem: 2.5 } as const;
export const LANE_PADDING_REM = 1;
export const LANE_PADDING_IGNORED_REM = 1.5;
export const ROW_MIN_HEIGHT_REM = 4.6875;
/** Mobile (Figma): linhas de 73px e meses de ~61px. */
export const MOBILE_ROW_MIN_HEIGHT_REM = 4.5625;
